
import axios from "axios";
import * as actionType from "../../constant/actionType";

export const GetProviderTypeByIdClient = (apiData) => async (dispatch) => {
    /*** API Call Action ***/
    const storedData = JSON.parse(localStorage.getItem("LoginUserData"));
    try {
      const response = await axios({
        method: 'get',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('conserve_authtoken')}`,
          organisationid: storedData?.organisation_id,
        },
        url: `${actionType.environment_url}/api/client/GetProviderTypeById`,
        params: apiData
      });
      return response.data
      
    } catch (error) {
        return error.message  
    }
  };

  